/**
 * Helper
 */
var helper = require('../../helper');

$(function() {
    $('.datatable-employment-history-of-guardian').each(function () {
        let userableId = $(this).data('userable_id'),
            $datatable = $('#datatable-employment-history-of-guardian-'+userableId);

        $datatable.DataTable({
            "dom": "<'dt-toolbar dt-toolbar-no-buttons'lf>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "processing": true,
            "serverSide": true,
            "responsive": true,
            "lengthMenu": [ 10, 50, 100],
            "ajax": helper.getOrigin() + "/api/employment-history/"+userableId,
            "bAutoWidth" : false,
            "order": [[ 2, "asc" ]],
            "columns": [
                {data: 'id', name: 'id', visible: false},
                {data: 'company_name', name: 'company_name'},
                {data: 'date_start', name: 'date_start'},
                {data: 'date_end', name: 'date_end'},
                {
                    data: 'actions',
                    name: 'actions',
                    orderable: false,
                    searchable: false,
                    className : "action"
                }
            ]
        });
    })
});
